import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { Dispatch } from 'redux';
import styled from 'styled-components';
import { GIButton } from 'app-components';

import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import parse from 'html-react-parser';

import UniversalInput from '../../../../lib/wrappers/UniversalInput';
import { INPUT_TYPES } from '../../../../constants/inputs/inputTypes';
import Form from '../../../../lib/wrappers/Form';
import { IUserInfo } from '../../types/ridpTypes';
import { useAppSelector, useAppDispatch } from '../../../../hooks';
import { StyledIdentityHeader } from '../Layout';
import { DROPDOWN_OPTIONS } from '../../../../constants/ssap/hhmTypes/dropdownOptions';
import { VALIDATION_TYPES } from '../../../../constants/inputs/validationTypes';
import { VALIDATION_ERROR_MESSAGES } from '../../../../constants/inputs/validationErrorMessages';
import { validateRidpPrimary } from '../../../../actions/ridp/ridpActionCreators';
import endpoints from '../../../../constants/configs/endpoints';
import ErrorMessage from '../../../../components/common/form/errorMessage';
import { useHandleRIDPResponse } from '../../utils/useHandleRidpResponse';
import { ResponseCodes } from '../../types/responseCodes';
import { configs } from '../../../../constants/configs/configs';
import { BREAK_POINTS } from '../../../../constants/common/breakpoints';
import DatePicker from '../../../../lib/inputs/react-datepicker';
import { formatDateToMMDDYYYY } from '../../../../utils/dates/dateMethods';
import AlertMessage from '../../../../components/individualPortal/dashboard/AlertMsgs/AlertMessage';

const StyledContactInformationContainer = styled.div`
    .regular-input {
        display: flex;
        align-items: center;

        &.input-mobile {
            > input {
                @media (max-width: ${BREAK_POINTS.sm}) {
                    width: 100%;
                }
            }
        }

        > label {
            font-size: 16px;
            color: ${({ theme }) => theme.gray2};
            width: 200px;
            text-align: right;
            &.required-true::after {
                margin-left: 3px;
                color: ${({ theme }) => theme.dangerMain};
            }
            @media (max-width: ${BREAK_POINTS.sm}) {
                text-align: left;
            }
        }
        > input {
            width: 220px;
            height: 30px !important;
            font-size: 14px;
            border: ${({ theme }) => `1px solid ${theme.gray4}`};
            border-radius: 2px;
            color: ${({ theme }) => theme.gray3};
            @media (max-width: ${BREAK_POINTS.sm}) {
                width: 55%;
            }
        }
    }
    .small-width {
        > input {
            width: 150px;
            @media (max-width: ${BREAK_POINTS.sm}) {
                width: 100%;
            }
        }
    }
    .gi-alert__info {
        color: ${({ theme }) => theme.primaryDark};
        border-left: ${({ theme }) => `3px solid ${theme.primaryMain}`};
        padding: 16px;
        margin-top: 30px;
    }
    .gi-dropdown {
        margin: 0;
        display: flex;
        margin-top: 1.5rem;

        > label {
            font-size: 16px;
            color: ${({ theme }) => theme.gray2};
            width: 200px;
            text-align: right;
            &.required-true::after {
                margin-left: 3px;
                color: ${({ theme }) => theme.dangerMain};
            }
            @media (max-width: ${BREAK_POINTS.sm}) {
                text-align: left;
            }
        }

        > select {
            height: 30px !important;
            font-size: 14px;
            border: ${({ theme }) => `1px solid ${theme.gray4}`};
            border-radius: 2px;
            color: ${({ theme }) => theme.gray3};
        }

        .input-error {
            border: ${({ theme }) => `1px solid ${theme.dangerMain}`};
        }
    }
    .gi-component {
        .small-width {
            width: 150px;
            @media (max-width: ${BREAK_POINTS.sm}) {
                width: 100%;
            }
        }
        .react-datepicker-wrapper {
            .react-datepicker__input-container {
                > input {
                    display: flex;
                    text-align: start;
                    height: 30px !important;
                    width: 150px !important;
                    font-size: 14px;
                    border: ${({ theme }) => `1px solid ${theme.gray4}`};
                    border-radius: 2px;
                    color: ${({ theme }) => theme.gray3};
                    @media (max-width: ${BREAK_POINTS.sm}) {
                        width: 100% !important;
                    }
                }
            }
            @media (max-width: ${BREAK_POINTS.sm}) {
                width: 100%;
            }
        }
    }
    .input-error {
        > input {
            border: ${({ theme }) => `1px solid ${theme.dangerMain}`};
        }
    }
`;

const StyledButton = styled.div`
    width: 100%;
    display: flex;
    justify-content: end;
    padding-right: 25px;
    padding-bottom: 25px;

    @media (max-width: ${BREAK_POINTS.sm}) {
        padding-right: 0px;
        margin-top: 20px;
        > button {
            width: fit-content;
        }
    }
`;
const StyledField = styled.div`
    display: flex;
    gap: 20px;
    margin-top: 20px;

    .gi-input,
    .gi-component,
    .grid-row {
        display: flex;
        justify-content: center;
        margin-top: 0 !important;

        .gi-input__label,
        .usa-legend {
            width: 200px !important;
            color: ${({ theme }) => theme.gray2};
            letter-spacing: 0;
            float: left;
            font-size: 1.6rem;
            padding: 0 1rem;
            text-align: right;
            font-weight: 500;
        }

        input,
        .usa-list {
            display: flex;
            text-align: start;
            height: 30px !important;
            width: 150px !important;
            font-size: 14px;
            border: ${({ theme }) => `1px solid ${theme.gray4}`};
            border-radius: 2px;
            color: ${({ theme }) => theme.gray3};
            @media (max-width: ${BREAK_POINTS.sm}) {
                width: 100% !important;
            }
        }

        @media (max-width: 768px) {
            flex-direction: column;
            justify-content: center;

            .gi-input__input,
            .gi-input__label,
            .usa-legend,
            input,
            select,
            .usa-list,
            .react-datepicker-wrapper {
                min-width: 100%;
                text-align: left;
            }
        }
    }
    .date-picker,
    .shown.error--msg {
        margin-top: 0 !important;
        padding: 8px;
    }
    @media (max-width: 768px) {
        flex-direction: column;
        justify-content: center;
    }

    .gi-dropdown {
        margin: 0;
    }
`;

const ContactInformation = () => {
    const dispatch: Dispatch<any> = useAppDispatch();
    const navigate = useNavigate();
    const params = new URLSearchParams(window.location.search);
    const currentUserInfo = useAppSelector(state => state.ridp.currentUserInfo);
    const errorMsg = useAppSelector(state => state.ridp.responseBasedErrorMessage);
    const [userInfo, setUserInfo] = useState<IUserInfo>(currentUserInfo as IUserInfo);
    const ridpPrimaryResponse = useAppSelector(state => state.ridp.ridpPrimaryResponse);
    const responseCode = ResponseCodes.HS000000;
    const [errors, setErrors] = useState({
        personGivenName: false,
        personSurName: false,
        streetName: false,
        locationCityName: false,
        locationStateUSPostalServiceCode: false,
        locationPostalCode: false,
    });
    const [errorMessage, setErrorMessage] = useState('');
    const {
        routes: { RIDP_VERIFICATION_COMPLETE },
    } = configs;

    const {
        personGivenName,
        personMiddleName,
        personBirthDate,
        personNameSuffixText,
        personSurName,
        streetName,
        fullTelephoneNumber,
        locationCityName,
        locationStateUSPostalServiceCode,
        locationPostalCode,
        personSSNIdentification = '', //set SSN as empty string
    } = userInfo;

    const intlTagFormatter = useIntl();

    const caseNumber = params.get('caseNumber');
    const coverageYear = params.get('coverageYear');
    const applicationType = params.get('applicationType');

    const onFieldChange = (...args) => {
        const [newData] = args;
        setUserInfo({ ...newData });
    };

    useEffect(() => {
        if (userInfo.verifyStatus === 'completed') {
            navigate(
                `${RIDP_VERIFICATION_COMPLETE}?caseNumber=${caseNumber}&applicationType=${applicationType}&coverageYear=${coverageYear}`,
            );
            return;
        }
        validateField();
    }, [userInfo]);

    useEffect(() => {
        setUserInfo(currentUserInfo as IUserInfo);
    }, [currentUserInfo, setUserInfo]);

    const validateField = useCallback(() => {
        Object.keys(errors).forEach(errorVar => {
            setErrors(error => {
                return {
                    ...error,
                    [errorVar]: !userInfo[errorVar]?.trim(),
                };
            });
        });
    }, [errors, setErrors, userInfo]);

    const isButtonDisabled = useMemo(() => {
        return Object.keys(errors).some(value => errors[value]);
    }, [errors]);

    const submitContactInformationHandler = event => {
        event.preventDefault();
        dispatch(validateRidpPrimary(endpoints.RIDP_VALIDATE_PRIMARY_ENDPOINT, userInfo, responseCode));
    };

    const handleDateChange = (date: string | null) => {
        const formattedDate = formatDateToMMDDYYYY(date);
        setUserInfo({ ...userInfo, personBirthDate: formattedDate || '' });
    };

    useHandleRIDPResponse(ridpPrimaryResponse, userInfo, setErrorMessage);

    return (
        <>
            <StyledContactInformationContainer>
                <StyledIdentityHeader>
                    <FormattedMessage id="ridp.sidebar.contactInformation" />
                </StyledIdentityHeader>
                <AlertMessage content={parse(intlTagFormatter.formatMessage({id:'ridp.contactinfo.alert.para'}))} type={'info'} />
                {errorMsg && <ErrorMessage messageText={errorMsg} isVisible={true} />}
                {errorMessage && <ErrorMessage messageText={errorMessage} isVisible={true} />}

                <Form {...{ formName: 'ridpUserInfo', action: {} }}>
                    <UniversalInput
                        label={{
                            text: 'ridp.contactinfo.input.label.firstName',
                            labelClasses: ['spl__width--01'],
                        }}
                        inputData={{
                            isInputRequired: true,
                            type: INPUT_TYPES.REGULAR_INPUT,
                            name: 'personGivenName',
                            value: personGivenName,
                            placeholder: '',
                            currentData: userInfo,
                            fields: [],
                            isInputStandalone: true,
                            helperClasses: [
                                'control-label',
                                'regular-input',
                                `${errors.personGivenName ? 'input-error' : ''}`,
                            ],
                            validationErrorMessage: VALIDATION_ERROR_MESSAGES.FIRST_NAME,
                        }}
                        inputActions={{
                            onFieldChange,
                            onFieldBlur: validateField,
                        }}
                        parentForm={{ name: 'ridpUserInfo' }}
                    />
                    <UniversalInput
                        label={{
                            text: 'ridp.contactinfo.input.label.middleName',
                            labelClasses: ['spl__width--01'],
                        }}
                        inputData={{
                            isInputRequired: false,
                            type: INPUT_TYPES.REGULAR_INPUT,
                            name: 'personMiddleName',
                            value: personMiddleName,
                            placeholder: '',
                            currentData: userInfo,
                            fields: [],
                            isInputStandalone: true,
                            helperClasses: ['control-label', 'regular-input'],
                        }}
                        inputActions={{
                            onFieldChange,
                        }}
                        parentForm={{ name: 'ridpUserInfo' }}
                    />
                    <UniversalInput
                        label={{
                            text: 'ridp.contactinfo.input.label.lastName',
                            labelClasses: ['spl__width--01'],
                        }}
                        inputData={{
                            isInputRequired: true,
                            type: INPUT_TYPES.REGULAR_INPUT,
                            name: 'personSurName',
                            value: personSurName,
                            placeholder: '',
                            currentData: userInfo,
                            fields: [],
                            isInputStandalone: true,
                            helperClasses: [
                                'control-label',
                                'regular-input',
                                `${errors.personSurName ? 'input-error' : ''}`,
                            ],
                        }}
                        inputActions={{
                            onFieldChange,
                            onFieldBlur: validateField,
                        }}
                        parentForm={{ name: 'ridpUserInfo' }}
                    />
                    <UniversalInput
                        label={{
                            text: 'ridp.contactinfo.input.label.suffix',
                            isLabelRequired: false,
                        }}
                        inputData={{
                            isInputRequired: false,
                            type: INPUT_TYPES.DROPDOWN,
                            name: 'personNameSuffixText',
                            value: personNameSuffixText,
                            options: DROPDOWN_OPTIONS.SUFFIX,
                            currentData: userInfo,
                            fields: [],
                            isInputStandalone: true,
                            validationType: VALIDATION_TYPES.CHOSEN,
                            inputClass: ['small-width'],
                        }}
                        inputActions={{
                            onFieldChange,
                        }}
                    />
                    <StyledField>
                        <DatePicker
                            labelText="ridp.contactinfo.input.label.dob"
                            wrapperClasses={['grid-row', 'gi-component', 'gi-dropdown', 'date-picker']}
                            id="ridpDatepicker"
                            type="text"
                            placeholder="MM/DD/YYYY"
                            showIcon={false}
                            pattern="MM/DD/YYYY"
                            value={personBirthDate ? new Date(personBirthDate) : ''}
                            withMask
                            showYearDropdown={false}
                            onDateChange={value => handleDateChange(value || '')}
                        />
                    </StyledField>
                    <UniversalInput
                        label={{
                            text: 'ridp.contactinfo.input.label.ssn',
                            labelClasses: ['spl__width--01'],
                        }}
                        inputData={{
                            isInputRequired: false,
                            type: INPUT_TYPES.SSN_INPUT,
                            name: 'personSSNIdentification',
                            value: personSSNIdentification,
                            placeholder: '',
                            currentData: userInfo,
                            fields: [],
                            isInputStandalone: true,
                            helperClasses: ['control-label', 'regular-input', 'small-width'],
                        }}
                        inputActions={{
                            onFieldChange,
                        }}
                        parentForm={{ name: 'ridpUserInfo' }}
                    />
                    <UniversalInput
                        label={{
                            text: 'ridp.contactinfo.input.label.address',
                            labelClasses: ['spl__width--01'],
                        }}
                        inputData={{
                            isInputRequired: true,
                            type: INPUT_TYPES.REGULAR_INPUT,
                            name: 'streetName',
                            value: streetName,
                            placeholder: '',
                            currentData: userInfo,
                            fields: [],
                            isInputStandalone: true,
                            helperClasses: [
                                'control-label',
                                'regular-input',
                                `${errors.streetName ? 'input-error' : ''}`,
                                'input-mobile',
                            ],
                        }}
                        inputActions={{
                            onFieldChange,
                            onFieldBlur: validateField,
                        }}
                        parentForm={{ name: 'ridpUserInfo' }}
                    />
                    <UniversalInput
                        label={{
                            text: 'ridp.contactinfo.input.label.city',
                            labelClasses: ['spl__width--01'],
                        }}
                        inputData={{
                            isInputRequired: true,
                            type: INPUT_TYPES.REGULAR_INPUT,
                            name: 'locationCityName',
                            value: locationCityName,
                            placeholder: '',
                            currentData: userInfo,
                            fields: [],
                            isInputStandalone: true,
                            helperClasses: [
                                'control-label',
                                'regular-input',
                                `${errors.locationCityName ? 'input-error' : ''}`,
                                'input-mobile',
                            ],
                        }}
                        inputActions={{
                            onFieldChange,
                            onFieldBlur: validateField,
                        }}
                        parentForm={{ name: 'ridpUserInfo' }}
                    />
                    <UniversalInput
                        label={{
                            text: 'ridp.contactinfo.input.label.state',
                            isLabelRequired: false,
                        }}
                        inputData={{
                            isInputRequired: true,
                            type: INPUT_TYPES.DROPDOWN,
                            name: 'locationStateUSPostalServiceCode',
                            value: locationStateUSPostalServiceCode,
                            options: DROPDOWN_OPTIONS.STATE,
                            currentData: userInfo,
                            fields: [],
                            isInputStandalone: true,
                            validationType: VALIDATION_TYPES.CHOSEN,
                            inputClass: [
                                'small-width',
                                `${errors.locationStateUSPostalServiceCode ? 'input-error' : ''}`,
                            ],
                        }}
                        inputActions={{
                            onFieldChange,
                            onFieldBlur: validateField,
                        }}
                    />
                    <UniversalInput
                        label={{
                            text: 'ridp.contactinfo.input.label.zipCode',
                            labelClasses: ['spl__width--01'],
                        }}
                        inputData={{
                            isInputRequired: true,
                            type: INPUT_TYPES.REGULAR_INPUT,
                            name: 'locationPostalCode',
                            value: locationPostalCode,
                            placeholder: '',
                            currentData: userInfo,
                            fields: [],
                            isInputStandalone: true,
                            helperClasses: [
                                'control-label',
                                'regular-input',
                                'small-width',
                                `${errors.locationPostalCode ? 'input-error' : ''}`,
                            ],
                        }}
                        inputActions={{
                            onFieldChange,
                            onFieldBlur: validateField,
                        }}
                        parentForm={{ name: 'ridpUserInfo' }}
                    />
                    <UniversalInput
                        label={{
                            text: 'ridp.contactinfo.input.label.phone',
                            labelClasses: ['spl__width--01'],
                        }}
                        inputData={{
                            isInputRequired: false,
                            type: INPUT_TYPES.PHONE_NUMBER_INPUT,
                            name: 'fullTelephoneNumber',
                            value: fullTelephoneNumber,
                            placeholder: '',
                            currentData: userInfo,
                            fields: [],
                            isInputStandalone: true,
                            helperClasses: ['control-label', 'regular-input', 'small-width'],
                            validationType: VALIDATION_TYPES.PHONE_NUMBER,
                        }}
                        inputActions={{
                            onFieldChange,
                        }}
                        parentForm={{ name: 'ridpUserInfo' }}
                    />
                    <StyledButton>
                        <GIButton
                            type="submit"
                            id="ridpContactInfo"
                            labelId="ridp.contactinfo.input.label.continue"
                            onClickHandler={e => submitContactInformationHandler(e)}
                            isDisabled={isButtonDisabled}
                            data-testid={`ridpContactInfo`}
                        />
                    </StyledButton>
                </Form>
            </StyledContactInformationContainer>
        </>
    );
};

export default ContactInformation;
